export const clientInfoAdapter = (data) => {
	return [
		{
			key: data?._id,
			auth: data?.auth || '-',
			commune: data?.info?.commune || '-',
			coverage_type: data?.info?.coverage_type || '-',
			email: data?.info?.email || '-',
			first_name: data?.info?.first_name || '-',
			last_name: data?.info?.last_name || '-',
			location: data?.info?.location || '-',
			phone: data?.info?.phone || '-',
			rut: data?.info?.rut || '-',
			street: data?.info?.street || '-',
			street_number: data?.info?.street_number || '-',
			type_house: data?.info?.type_house || '-',
			type_retirement: data?.info?.type_retirement || '-',
			sex: data?.info.sex || '-',
		},
	];
};
